import { Menu } from 'antd';
import React from 'react';

export const FilterDropdown = ({ chooseFilter }) => (
  <Menu onClick={e => chooseFilter(e)}>
    <Menu.Item key="1">1st menu item</Menu.Item>
    <Menu.Item key="2">2nd menu item</Menu.Item>
    <Menu.Item key="3">3rd item</Menu.Item>
  </Menu>
);



// WEBPACK FOOTER //
// ./src/view/screens/Project/components/FilterDropdown/index.js